<template>
    <div class="backgroud-white cs-courseSchedule-editor">
        <div class="backgroud-gray-popup popup-content-area-small">
            <el-form ref="form" :model="form" :rules="rules">
                <el-form-item prop="UniversityId" label="学校：" label-width="100px" class="label-strong">
                    <el-select @change='checkAllInputs' v-model="form.UniversityId" placeholder="请选择">
                        <el-option v-for="item in universityList" :key="item.Key" :label="item.Value" :value="item.Key">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer popup-footer">
            <el-row>
                <el-col :span="20" :xs="16" class="footer-left">
                    <span v-if="!showError"></span>
                    <el-alert :closable="false" v-if="showError" v-bind:title="errorMessage" type="error" show-icon></el-alert>
                </el-col>
                <el-col class="footer-right" :span="4" :xs="8">
                    <el-button :type="submitBtnClass" @click="save()">确认修改</el-button>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import { getStore, setStore } from "../config/mUtils";
import { getUniversities } from "../service/common.service";
import { updateUniversity } from "../service/student.service";
export default {
  props: ["universityId"],
  data() {
    getUniversities().then(result => {
      if (!!result && result.success) {
        this.universityList = result.data;
      }
    });
    return {
      universityList: [],
      showError: false,
      errorMessage: "",
      submitBtnClass: "primary",
      form: {
        StudentId: 0,
        UniversityId: ""
      },
      rules: {
        UniversityId: [
          {
            required: true,
            message: "请选择所属学校",
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    this.$data.form.StudentId = getStore("user_student_id");
    this.$data.form.UniversityId = this.$props.universityId;
  },
  watch:{
    universityId:function(){
      this.$data.form.UniversityId = this.$props.universityId;
    }
  },
  methods: {
    checkAllInputs() {
      let isValid = true;
      this.$refs.form.validate(valid => {
        if (!valid) {
          isValid = false;
          return;
        }
        this.submitBtnClass = "primary";
      });
      if (isValid) {
        this.submitBtnClass = "primary";
      } else {
        this.submitBtnClass = "info";
      }
    },
    async save() {
      let valid = true;
      this.$refs.form.validate(valid => {
        if (!valid) {
          valid = false;
        }
      });
      if (!valid) return;
      let result = await updateUniversity(this.$data.form);
      if (result) {
        if (!result.success) {
          this.errorMessage = result.message;
          this.showError = true;
        } else {
          this.showError = false;
          this.$refs.form.resetFields();
          this.$emit("saveSuccess", "university");
          this.$emit("closeEditor", "university");
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/universityEditor.vue